namespace RioERP.Masters {
    export interface DelhiveryApiDetailsRow {
        Id?: number;
        Token?: string;
        ShippingMode?: string;
        Name?: string;
        Address?: string;
        City?: string;
        Pincode?: string;
        Phone?: string;
        IsActive?: boolean;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace DelhiveryApiDetailsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Token';
        export const localTextPrefix = 'Masters.DelhiveryApiDetails';
        export const deletePermission = 'Masters:MastersManagement:Modify';
        export const insertPermission = 'Masters:MastersManagement:Modify';
        export const readPermission = 'Masters:MastersManagement:View';
        export const updatePermission = 'Masters:MastersManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            Token = "Token",
            ShippingMode = "ShippingMode",
            Name = "Name",
            Address = "Address",
            City = "City",
            Pincode = "Pincode",
            Phone = "Phone",
            IsActive = "IsActive",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
